<template>
<BaseLink
  :to="to"
  :show-icon="showIcon"
  :tag="isButton ? 'button' : undefined"
  class="ui-more-button-hina styled-default"
>
  <slot />
  <BaseIcon
    v-if="icon"
    class="icon"
    :name="icon"
    :size="iconSize"
  />
</BaseLink>
</template>

<script setup lang="ts">
import type { SVG_NAMES } from '~/components/icons'

interface Props {
  to?: string
  iconSize?: `size-${number}` | 'size-full' | 'size-none'
  icon?: SVG_NAMES
  showIcon?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  iconSize: 'size-4',
  showIcon: false,
})

const isButton = props.to === undefined
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;
@use "sass:color";

.ui-more-button-hina {
  display: inline-flex;
  align-items: center;
}

.styled-default {
  color: $hina-link;

  &:hover {
    text-decoration: underline;
  }

  &:visited,
  &:visited .icon {
    color: color.adjust($jps-key-blue, $lightness: -20%);
  }

  &:hover:visited,
  &:hover:visited .icon {
    color: color.adjust($jps-key-blue, $lightness: -30%);
  }
}
</style>
